// https://github.com/wojtekmaj/react-pdf/issues/1811
// https://github.com/wojtekmaj/react-pdf/issues/1831
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers#description
// @ts-expect-error This does not exist outside of polyfill which this is doing
if (typeof Promise.withResolvers === 'undefined') {
  // Check for window only on client side
  if (typeof window !== 'undefined') {
    // @ts-expect-error This is a polyfill
    window.Promise.withResolvers = function () {
      let resolve;
      let reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, reject, resolve };
    };
  } else {
    // @ts-expect-error This is a polyfill
    Promise.withResolvers = function () {
      let resolve;
      let reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, reject, resolve };
    };
  }
}
